import React from "react";
import TeacherSidebar from "../components/teachers/TeacherSidebar/TeacherSidebar";
import "../assests/css/teachers/TeacherMasterLayout.css";

const TeacherMasterLayout = ({ children }) => {
  return (
    <div className="tl-wrapper">
      {/* Sidebar */}
     
        <TeacherSidebar />
   

      {/* Main Content */}
      <main className="tl-content">
        {children}
      </main>
    </div>
  );
};

export default TeacherMasterLayout;